// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + (chunkId === "460" ? "quickjs-sandbox" : chunkId) + "." + {"396": "fd9de97c8047d0be","460": "682dd654bd30ce1a","917": "4c15878da4343c0c","985": "436300c9a2b1ffc9",}[chunkId] + ".chunk.js"
}